const EMPTY_VALUE = "-";

/**
 * Two-line table cell: a human-readable "time ago" label above the absolute date.
 * An optional caption adds a third, subtler line describing the event or source.
 */
export const RelativeDateCell = ({
  relative,
  absolute,
  caption,
}: {
  relative: string;
  absolute: string;
  caption?: string;
}) => {
  if (!relative && !absolute) {
    return <>{EMPTY_VALUE}</>;
  }

  return (
    <div className="flex flex-col">
      <span className="text-foreground">{relative || EMPTY_VALUE}</span>
      {absolute ? <span className="text-xs text-muted-foreground">{absolute}</span> : null}
      {caption ? (
        <span className="mt-0.5 text-xs font-medium text-muted-foreground/80">{caption}</span>
      ) : null}
    </div>
  );
};
